import { useContext, useEffect } from "react";
import { InfoSnackbarContext } from "../contexts/InfoSnackbarContext";

const useInfoSnackbar = (
  duration = 2000,
  verticalPosition = "top",
  horizontalPosition = "center",
) => {
  const {
    setDuration,
    setAnchorOrigin,
    alertError,
    alertInfo,
    alertSuccess,
    alertWarning,
  } = useContext(InfoSnackbarContext);

  useEffect(() => {
    setDuration(duration);
    setAnchorOrigin({
      vertical: verticalPosition,
      horizontal: horizontalPosition,
    });
  }, [
    setDuration,
    setAnchorOrigin,
    duration,
    verticalPosition,
    horizontalPosition]);

  return {
    alertError,
    alertInfo,
    alertSuccess,
    alertWarning,
  };
};

export default useInfoSnackbar;
